// Constantes compartidas del modulo Inventario.

export const PRODUCT_CATEGORIES = ['botox', 'filler', 'plasma', 'consumable', 'other'];

export const PRODUCT_CATEGORY_LABELS = {
  botox: 'Botox / Toxina',
  filler: 'Filler / Relleno',
  plasma: 'Plasma (PRP)',
  consumable: 'Consumible',
  other: 'Otro',
};

export const UNIT_SUGGESTIONS = ['unidades', 'ml', 'gr', 'cajas', 'kits', 'viales', 'ampollas'];

export function formatQty(value) {
  const n = Number(value);
  return n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
}
